import React from 'react';
import { Table } from 'semantic-ui-react';
import SimpleTwoColumnTableRow from './SimpleTwoColumnTableRow';
import axios from 'axios';
import { getLookupName } from './util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


// studentInfoPreviousEducations {}
export default class PreviousEducation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previousEducations: []
        };
    }

    componentDidMount() {
        axios({
            method: 'get',
            url: this.props.studentId === null ? '/students/previous-educations' : `/students/${this.props.studentId}/previous-educations`
        })
            .then(res => {
                this.setState({ previousEducations: res.data.reverse() });
            });
    }
    render() {
        const { previousEducations } = this.state;
        if (!previousEducations.length) return <div></div>;

        return (
            <Table celled size="small" unstackable compact>
                <Table.Header>
                    <Table.Row>
                    </Table.Row>
                </Table.Header>
                <Table.Body>{previousEducations.map(el =>
                    (<SimpleTwoColumnTableRow
                        name={el.institution.type ? getLookupName(el.institution.type).substring(0, 1).toUpperCase() + getLookupName(el.institution.type).substring(1) : ''}
                        keyName="institution"
                        value={el.educationLevel ? el.institution.name + ' | ' + getLookupName(el.educationLevel) : el.institution.name}
                    />
                    ))}
                </Table.Body>
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/PreviousEducationTable.js